(function () {
    'use strict';

    angular
        .module('app')
        .controller('UnsavedChangesDialogCtrl', UnsavedChangesDialogCtrl);

    UnsavedChangesDialogCtrl.$inject = ['DialogInstance', 'name', 'threeOptions', 'body'];

    /**
     * @ngdoc Controller
     * @description
     * Dialog used to prompt the user if they wish to show unsaved changes
     *
     * @param {string} name - Name of the item with unsaved changes.
     * @param {bool} threeOptions - Should three options be shown on the dialog, e.g. Cancel, No and Yes
     * @param {string} body - HTML formatted text used for the body. Optional. If not supplied the default dialog template will be used.
     *
     * @returns {promise} A promise that resolves if the user selects yes/no with the values true and false respectively, otherwise rejects.
     */
    function UnsavedChangesDialogCtrl(DialogInstance, name, threeOptions, body) {
        var defaultBodyTemplate = '<p>The ' + (name ? name : 'item') + ' has unsaved changes.</p>' +
                          '<p>Do you wish to save the changes?</p>';

        /* jshint validthis:true */
        var vm = this;
        vm.cancel = cancel;
        vm.no = no;
        vm.yes = yes;
        vm.threeOptions = threeOptions;
        vm.body = body ? body : defaultBodyTemplate;

        function cancel() {
            DialogInstance.cancel();
        }

        function no() {
            DialogInstance.ok(false);
        }

        function yes() {
            DialogInstance.ok(true);
        }
    }
})();
